import type { HTMLAttributes } from 'react';
import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const RotatingSpinner = styled.div`
  border: 2px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  border-top: 2px solid
    ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${rotate360} 0.8s linear infinite;
  margin: 0 auto;
`;

export const DocumentsContainer = styled.div<
  { $disableLegacyStyles?: boolean } & HTMLAttributes<HTMLDivElement>
>`
  display: flex;
  flex-direction: column;
  align-items: top;
  ${(props) =>
    props.$disableLegacyStyles
      ? ''
      : `
  width: 100%;
  height: 100%;
  padding: 25px 20px 20px 20px;
  `}
`;

export const DocumentHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  button {
    margin-left: 10px;
  }
`;

export const FilePondContainer = styled.div`
  flex-grow: 2;
  .filepond--credits {
    display: none;
  }

  .filepond--wrapper {
    flex-grow: 2;
    margin: 0 0 0 10px;
    border: none;
  }
  .filepond--root {
    margin-bottom: 0;
  }

  .filepond--drop-label {
    position: relative;
    width: 100px;
    width: fit-content;
    align-items: flex-start;

    label {
      cursor: pointer;
      background-color: ${(props) =>
        props.theme.atlas.semantic.color.surface.variant};
      border-radius: 8px;
      display: flex;
      align-items: center;
      font-size: 10px;
      color: ${(props) => props.theme.atlas.semantic.color.type.default};
      padding: 8px 25px;

      img {
        padding-right: 10px;
      }

      cursor: pointer;
    }
  }

  .filepond--item {
    width: calc(50% - 0.5em);
  }

  .filepond--root .filepond--item-panel {
    background-color: white;
  }

  .filepond--root
    [data-filepond-item-state='processing-complete']
    .filepond--item-panel {
    background-color: white;
  }

  .filepond--root .filepond--panel-root {
    background-color: white;
  }

  .filepond--root .filepond--file {
    padding: 10px;
    border: 1px solid grey;
    border-radius: 6px;
  }
`;

export const ButtonsContainer = styled.div`
  height: 38px;
  display: flex;
`;

export const DragDropLabel = styled.label`
  width: 100%;
  margin-left: 40px;
  max-width: 320px;
  min-width: 180px;
  min-height: 60px;
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
  border: 1.5px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px auto;
  box-sizing: border-box;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  &:hover,
  &:focus {
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
    box-shadow: 0 0 0 2px
      ${(props) => props.theme.atlas.semantic.color.action.primary.default}33;
  }
`;

export const DragDropText = styled.div`
  font-weight: 400;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  font-size: 13px;
  margin-bottom: 6px;
`;

export const BrowseText = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  cursor: pointer;
  text-decoration: underline;
`;

export const FileSizeLimitText = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  font-size: 11px;
  margin-bottom: 2px;
`;

export const UnsupportedFileTypeMsg = styled.div`
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.destructive.default};
  font-size: 0.85em;
  margin-top: 4px;
  margin-left: 90px;
  font-weight: 500;
`;
